export enum ProjectAppTypes {
  AS = 'AS',
  PF = 'PF',
}

export enum WeldMilestoneType {
  FITUP = 'FITUP',
  INSTALL = 'INSTALL',
}
